// Generated by purs version 0.15.15
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Services_Clients_Interop_IO from "../Ouroboros.Services.Clients.Interop.IO/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
import * as Ouroboros_Services_Clients_Interop_Task from "../Ouroboros.Services.Clients.Interop.Task/index.js";
import * as Ouroboros_Services_Clients_Interop_TaskEither from "../Ouroboros.Services.Clients.Interop.TaskEither/index.js";
var toLoadingErrorInput = function (message) {
    return {
        message: Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText(message),
        info: Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)
    };
};
var runLoadingAction = function (v) {
    return v;
};
var readOption = function (v) {
    return v;
};
var handleLoadSuccess = function (kernel) {
    return function (response) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetMaybe(kernel.loadError))(Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit)), Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(kernel.plan))(response), runLoadingAction(kernel.loading.setSuccess) ]));
    };
};
var formatError = function (errorValue) {
    var $8 = errorValue.type === "Forbidden";
    if ($8) {
        return "Only super admins can view plan details.";
    };
    var $9 = errorValue.type === "Unauthorized";
    if ($9) {
        return "Please sign in again to continue.";
    };
    var message = Ouroboros_Models_Brands_ErrorMessageText.unwrap(errorValue.message);
    var $10 = message === "";
    if ($10) {
        return "Something went wrong.";
    };
    return message;
};
var handleLoadError = function (kernel) {
    return function (errorValue) {
        var message = formatError(errorValue);
        return Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Services_Clients_Interop_IO.sequenceOk([ Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(kernel.loadError))(message), runLoadingAction(kernel.loading.setError(toLoadingErrorInput(message))) ]));
    };
};
var loadPlanTask = function (kernel) {
    return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
        return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleLoadError(kernel))(handleLoadSuccess(kernel))(kernel.adminPlanClient.getPlan);
    })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(kernel.loading.setLoading)));
};
var documentationPath = "/documentation/drafting/frontend-program-builder/controllers/admin_plan_controller.md";
var buildOnInit = function (kernel) {
    return Ouroboros_Services_Clients_Interop_Option.fold(function (v) {
        return Ouroboros_Services_Clients_Interop_Option.some(Ouroboros_Programs_Capabilities.runTaskRunner(kernel.taskRunner)(loadPlanTask(kernel)));
    })(function (v) {
        return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
    })(readOption(Ouroboros_Programs_Capabilities.optionStateHandleRead(kernel.plan)));
};
export {
    buildOnInit,
    documentationPath
};
//# sourceMappingURL=index.js.map
